import { format } from '@/asset/js/i18n';

export const ROLE = {
  ANCHOR: 'ANCHOR',
  SPONSER: 'SPONSER',
};

export const TIME = {
  DAILY: 'DAILY',
  TOTAL: 'TOTAL',
};

export const TABLE = {
  anchorDaily: {
    title: [format('anchor.pk.rank'), format('anchor.pk.target'), format('anchor.pk.rewards')],
    content: ['diamondTarget', 'coinsRewards'],
  },
  userDaily: {
    title: [format('anchor.pk.rank'), format('anchor.pk.rewards'), format('anchor.pk.duration')],
    content: ['rewards', 'duration'],
  },
  userTotal: {
    title: [format('anchor.pk.rank'), format('anchor.pk.target'), format('anchor.pk.coins'), format('anchor.pk.rewards'), format('anchor.pk.duration')],
    content: ['diamondTarget', 'coinsRewards', 'rewards', 'duration'],
  },
  anchorTotal: {
    title: [format('anchor.pk.rank'), format('anchor.pk.target'), format('anchor.pk.rewards'), format('anchor.pk.tools.rewards'), format('anchor.pk.duration')],
    content: ['diamondTarget', 'coinsRewards', 'rewards', 'duration'],
  },
};

export const TABLE_NAME = ['anchorDaily', 'anchorTotal', 'userDaily', 'userTotal'];

export const ACTIVITY_STATUS = {
  END: 2,
};
